import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { COMPANY } from "@/mock";

const Hero = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[88vh] w-full overflow-hidden bg-brand-ink"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1639751787355-bbc3ed1fd639?q=85&w=2400&auto=format&fit=crop"
          alt="Modern luxury kitchen renovation"
          className="w-full h-full object-cover"
        />
        {/* Side gradient to keep image visible */}
        <div className="absolute inset-0 bg-gradient-to-r from-brand-ink/95 via-brand-ink/65 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/40 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 pt-32 pb-20 min-h-[88vh] flex flex-col justify-end">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8 animate-fade-up">
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-brand-cta mb-6 flex items-center gap-3">
              <span className="block w-10 h-px bg-brand-cta" />
              Residential Remodeling · Est. {COMPANY.founded}
            </p>
            <h1 className="font-heading text-5xl sm:text-6xl lg:text-[5.5rem] font-black tracking-tighter text-white leading-[0.95] mb-8">
              Built by hand. <br />
              <span className="italic font-light">Built to last.</span>
            </h1>
            <p className="text-lg sm:text-xl text-white/80 max-w-xl leading-relaxed font-light">
              JMJC Contracting transforms tired kitchens, dated baths, and worn
              floors into spaces that feel deliberate &mdash; and stay that way
              for decades.
            </p>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-3 animate-fade-up animate-delay-200">
            <Link
              to="/contact"
              data-testid="hero-cta-quote"
              className="group inline-flex items-center justify-between gap-3 px-7 py-5 bg-brand-cta hover:bg-brand-ctaHover text-white text-sm font-bold uppercase tracking-[0.16em] transition-all"
            >
              Get a Free Quote
              <ArrowUpRight
                className="w-5 h-5 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
                strokeWidth={2}
              />
            </Link>
            <a
              href={`tel:${COMPANY.phone.replace(/[^0-9+]/g, "")}`}
              data-testid="hero-cta-call"
              className="inline-flex items-center justify-between gap-3 px-7 py-5 border border-white/30 hover:border-white text-white text-sm font-bold uppercase tracking-[0.16em] transition-colors backdrop-blur-sm"
            >
              {COMPANY.phone}
              <Phone className="w-5 h-5" strokeWidth={2} />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom marker */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 pb-8">
        <div className="flex items-center gap-4 text-white/60 text-xs uppercase tracking-[0.2em]">
          <span className="block w-12 h-px bg-white/40" />
          Tile · Flooring · Drywall · Kitchen · Bath
        </div>
      </div>
    </section>
  );
};

export default Hero;
